import getDaysInMonth from 'date-fns/getDaysInMonth';
import { type IntlShape } from 'react-intl-next';

import { NavigationPeriodId } from '../../common/constants';
import { commonMessages } from '../../index';
import { NowLocation } from '../constants/schedule';

/**
 * @returns Before | After | InRange
 */
export const getNowLocation = (startEpoch: number, endEpoch: number, nowEpoch: number) => {
	if (nowEpoch > endEpoch) {
		return NowLocation.After;
	}

	if (nowEpoch < startEpoch) {
		return NowLocation.Before;
	}

	return NowLocation.InRange;
};

/**
 * @returns number of days in the given timeline
 */
export const getNumberOfDays = (timelineType: NavigationPeriodId, currentDate: Date): number => {
	switch (timelineType) {
		case NavigationPeriodId.OneDay:
			return 1;
		case NavigationPeriodId.OneWeek:
			return 7;
		case NavigationPeriodId.TwoWeeks:
			return 14;
		case NavigationPeriodId.OneMonth:
			return getDaysInMonth(currentDate);
	}
};

export const generateName = (scheduleName: string, intlApi: IntlShape) => {
	return intlApi.formatMessage(commonMessages.copyOfScheduleName, { scheduleName });
};
